import { Ability, type AbilityClass, type ExtractSubjectType, type MongoQuery, type SubjectRawRule } from '@casl/ability';

import type { CaslAction, CaslSubject } from ':helpers/casl/casl.enum';

export type AppAbility = Ability<[CaslAction, CaslSubject]>;
export const AppAbility = Ability as AbilityClass<AppAbility>;

export type AppCaslRule = SubjectRawRule<CaslAction, ExtractSubjectType<CaslSubject>, MongoQuery>;
